   const checkStatus = async (response) => {
  if (response.status >= 200 && response.status < 300) 
    return await response.json()
  throw await response.json()
}

export default checkStatus;